module.exports = "/images/property-placeholder.png?5f3a7a9d65fc3cc3e965866cb08e4879";